/**
 * Mutación para guardar el estado del usuario que ha iniciado sesión
 * @param { object } state Estado del módulo actual
 * @param { object } user Datos del usuario que ha iniciado sesión
 */
export function setUser(state, user) {
  const currentOrganization = state.user && state.user.organization;
  const nextOrganization = user && user.organization;
  const getOrganizationId = (organization) => {
    if (!organization) return null;
    return typeof organization === "object"
      ? organization._id || organization.id
      : organization;
  };

  if (
    !user ||
    user.role !== "ORGANIZATION_USER" ||
    !state.user ||
    state.user.role !== "ORGANIZATION_USER" ||
    getOrganizationId(currentOrganization) !== getOrganizationId(nextOrganization)
  ) {
    state.organizationProfilePicture = "";
  }

  state.user = user;
  state.loggedIn = true;
  // Mirror the user to localStorage so subsequent page loads and
  // refreshes see the latest data without having to re-fetch.
  try {
    if (user) {
      localStorage.setItem("USER_PROFILE", JSON.stringify(user));
    }
  } catch (storageErr) {
    console.warn(
      "[v2-profile] could not persist USER_PROFILE to localStorage",
      storageErr
    );
  }
}

/**
 * Función para agregar el token
 * @param {object} state El estado del módulo actual.
 */
 export function setToken(state, token) {
  state.token = token
}

/**
 * Función para cerrar la sesión, eliminar los datos del estado y borrar los datos del Local storage.
 * @param {object} state El estado del módulo actual.
 */
export function logout(state) {
  state.user = {}
  state.organizationProfilePicture = ''
  state.loggedIn = false;
  state.token = ''
  localStorage.removeItem('USER_TOKEN');
  localStorage.removeItem('USER_PROFILE');
}

export function setIndicators(state, indicators) {
  state.indicators = indicators;
}

export function setUserProfilePicture(state, imageUrl = '') {
  state.user.profilePicture = imageUrl;
  try {
    if (state.user) {
      localStorage.setItem("USER_PROFILE", JSON.stringify(state.user));
    }
  } catch (storageErr) {
    console.warn(
      "[v2-profile] could not persist USER_PROFILE to localStorage",
      storageErr
    );
  }
}

export function setOrganizationProfilePicture(state, imageUrl = "") {
  state.organizationProfilePicture = imageUrl;
}
